import { render, staticRenderFns } from "./wig-page-main-actions.vue?vue&type=template&id=70a2c86c"
import script from "./wig-page-main-actions.vue?vue&type=script&lang=js"
export * from "./wig-page-main-actions.vue?vue&type=script&lang=js"
import style0 from "./wig-page-main-actions.vue?vue&type=style&index=0&id=70a2c86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports